import React, { ComponentProps, FC, useCallback, useState } from 'react'
import { PopupFilter } from '../PopupFilter'
import { MultiSelectList } from '../MultiSelectList'
// create generic components with types
type Props = Omit<ComponentProps<typeof MultiSelectList>, 'selected' | 'defaultValue'> & {
  title: string
  defaultValue?: string[] | null | undefined
}

const defaultState: string[] = []

export const PopupMultiSelectFilter: FC<Props> = ({
  onChange,
  defaultValue = defaultState,
  title,
  ...props
}) => {
  const [selected, setSelected] = useState(defaultValue ?? defaultState)
  const onSave = useCallback(() => onChange(selected), [onChange, selected])
  const onClear = useCallback(() => {
    setSelected(defaultState)

    onChange(defaultState)
  }, [onChange])

  return (
    <PopupFilter title={title} onSave={onSave} onClear={onClear}>
      <MultiSelectList className='mt-4' {...props} selected={selected} onChange={setSelected} />
    </PopupFilter>
  )
}
